export { SORT_TYPES } from './sortTypes';

export const TOP_DONORS_COLUMNS = [
  { id: 'donor_name', label: 'Donor', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'email', label: 'Email', defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'total_donated', label: 'Total Donated', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'gift_count', label: 'Gifts', defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'avg_gift', label: 'Avg Gift', defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'last_gift_at', label: 'Last Gift', defaultVisible: true, sortable: true, sortType: 'date' },
];

export const getDefaultVisibleColumns = () =>
  TOP_DONORS_COLUMNS.filter((c) => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  TOP_DONORS_COLUMNS.filter((c) => !c.defaultVisible && !c.alwaysVisible);
